import React, { useState } from 'react';
import { Tooltip } from 'antd';
import {
  GridView,
  SimpleView,
  Widget,
  FormInput,
  FormSelect,
  Button,
  FilterWidget,
  usePromise,
  MasterDetailForm,
  FormSubmitButton,
  Table,
  CompositeView,
} from '@digital/ui';
import { getAllFornecedoresOptions } from '@app/api/fornecedor';
import { getTiposDocumentoCobrancaOptions } from '@app/api/tipoDocumentoCobranca';
import { getAutorizacaoMatchingInfo, download } from '@app/api/autorizacaoPagamento/autorizacao';
import { getAllSituacaoAutorizacao } from '@app/api/autorizacaoPagamento/matching';
import ModalMatching from './ModalMatching';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { currencyFormat } from '../../helpers/numbers';
import { FormSelectFilter } from '@app/components/FormSelectFilter';


const Matching = () => {

  const [autorizacoes, setAutorizacoes] = useState();

  const handleDownloadFile = (values: any) => download(values.localArquivo + '\\' + values.nomeArquivo, values.nomeArquivo);

  const columnAutorizacao = [
    {
      title: 'Fornecedor',
      dataIndex: 'fornecedor',
      width: '25%',
    },
    {
      title: 'Contrato',
      dataIndex: 'contrato',
      width: '10%',
    },
    {
      title: 'Número do Documento de Cobrança',
      dataIndex: 'documentoCobrancaNumero',
      width: '20%',
    },
    {
      title: 'Tipo de Documento',
      dataIndex: 'tipoDocumentoCobranca',
      width: '25%',
    },
    {
      title: 'Valor',
      dataIndex: 'valor',
      width: '10%',
      render: currencyFormat,
    },
    {
      title: 'Anexo',
      dataIndex: 'nomeArquivo',
      render: (nome, data) =>
        data.nomeArquivo && (
          <Tooltip title="Baixar Arquivo">
            <Button
              icon="ui-download"
              onClick={() => {
                handleDownloadFile(data);
              }}
            />
          </Tooltip>
        ),
      width: '5%',
    },
    {
      title: 'Matching',
      dataIndex: 'modal',
      render: (nome, data) => {
        return (
          <ModalMatching
            matchingOption={data.documentoCobrancaId == null ? '0' : data.documentoCobrancaId}
            idAutorizacao={data.id}
            statusCodigo={data.statusCodigo}
            numeroContrato={data.contrato}
          />
        );
      },
      width: '5%',
    },
  ];

  usePromise(
    () =>
      getAutorizacaoMatchingInfo({ id: 0, situacoesId: ['0', '1'] })
        .then((resp: any) => {
          setAutorizacoes(resp);
          return resp;
        }),
    [],
    [],
  );

  const handleSearch = (values: any) => {
    getAutorizacaoMatchingInfo(values)
      .then((resp: any) => {
        setAutorizacoes(resp);
        return resp;
      });
  };


  return (
    <CompositeView>
      <SimpleView>
        <GridView noform>
          <MasterDetailForm initialValues={{ situacoesId: ['0', '1'] }} onSubmit={handleSearch}>
            <FilterWidget
              active={[]}
              title="Pesquisa de Autorizações"
              actions={[
                <FormSubmitButton type="primary" icon={'commons-search'}>
                  Pesquisar
                </FormSubmitButton>,
              ]}>
              <FormSelectFilter
                label="Fornecedor"
                name="FornecedoresId"
                span={6}
                dataOptions={() => getAllFornecedoresOptions()}
              />
              <FormInput label="Nº Contrato" name="NumeroContrato" span={6} />
              <FormSelect
                mode="multiple"
                getOptions={getTiposDocumentoCobrancaOptions}
                label="Tipo de Documento de Cobrança"
                name="DocumentosCobrancaId"
                span={6}
              />
              <FormInput label="Valor Mínimo (Autorizacao)" name="valorminimo" span={3} />
              <FormInput label="Valor Máximo (Autorizacao)" name="valormaximo" span={3} />
              <FormSelect
                mode="multiple"
                label="Situação"
                name="situacoesId"
                getOptions={getAllSituacaoAutorizacao}
                span={6}
              />
            </FilterWidget>
          </MasterDetailForm>
          <Widget title="Autorizações">
            <PerfectScrollbar>
              <Table
                columns={columnAutorizacao}
                dataSource={autorizacoes}
                pagination={{ defaultPageSize: 50 }}
              />
            </PerfectScrollbar>
          </Widget>
        </GridView>
      </SimpleView>
    </CompositeView>
  );
};

export default Matching;
